 angular
   .module('vppApp')
   .factory('GetOfferYears', GetOfferYears);
 	GetOfferYears.$inject = ['$rootScope'];

 function GetOfferYears($rootScope) {
 	var GetOfferYears = {};
 		GetOfferYears.getYears = function (incentives) {
 			$rootScope.yearOptions = {};
	    var currYear = year.toString();
		    for (var key in incentives) {
		      $rootScope.yearOptions[key] = key;
		    }
		    $rootScope.selectedYear = $rootScope.yearOptions[currYear];
		  };
		  return GetOfferYears;
 }